import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import StoryblokEntryTemplateContext from '../../../interfaces/Storyblok/StoryblokEntryTemplateContext.interface';
import { getTemplate } from './DynamicTemplateMap';
import TemplateContext from '../../../contexts/TemplateContext';

interface DynamicTemplateProps {
  context: StoryblokEntryTemplateContext;
}

const DynamicTemplate: React.FC<DynamicTemplateProps> = ({ context }) => {
  const field_component = context.field_component ?? 'Page';

  const Template = getTemplate(field_component);

  const { countdowns } = useStaticQuery(graphql`
    {
      countdowns: allStoryblokEntry(sort: { fields: id }, filter: { field_component: { eq: "Countdown" } }) {
        edges {
          node {
            name
            full_slug
            content
          }
        }
      }
    }
  `);

  const getCountdownBlok = (content: any) => {
    const edges = content?.edges;
    if (!edges) return null;

    const domainAssociatedCountdownBlocks = edges.filter((edge: any) =>
      edge.node.full_slug.includes(process.env.GATSBY_DOMAIN_FOLDER),
    );

    const allCountdownBlocks = domainAssociatedCountdownBlocks.map((edge: any) => JSON.parse(edge.node.content));

    // Filter out countdowns that don't have this page uuid attached
    const countdownsForThisPageType = allCountdownBlocks.filter((countdown: any) =>
      countdown.show_on_content_types.includes(field_component),
    );

    // Take the highest priority countdown
    const countdownBlok = countdownsForThisPageType.sort((a: any, b: any) => a.priority - b.priority)[0];

    return countdownBlok;
  };

  const countdownBlok = getCountdownBlok(countdowns);

  // Per-page override: when the page has `hide_top_banner` enabled, the
  // site-wide top banner is suppressed for this page only (e.g. franchisee
  // service pages that shouldn't promote Head Office booking).
  const hideTopBanner = Boolean(context.content?.hide_top_banner);

  return (
    <TemplateContext.Provider value={{ contentType: field_component, hideTopBanner }}>
      <Template key={context.id} context={context} countdown={countdownBlok} />
    </TemplateContext.Provider>
  );
};

export default DynamicTemplate;
